import { Controller } from "@hotwired/stimulus"

const PRINT_COOLDOWN_MS = 3000

// Connects to data-controller="buscar-reportes"
export default class extends Controller {
  static targets = ["desde", "hasta", "obraSocial", "hoja", "count", "selectedList", "plantilla", "hojasToggle", "plantillaDescripcion"]
  static values = {
    url: String,
    registro: Number,
    processingReport: Boolean,
    typesCount: Number
  }

  connect() {
    this.processingReportValue = Boolean(this.data.get("processingReport"));
    this.updateHojaSummary();
    this.cambiarPlantilla();

    this.element.addEventListener('change', (e) => {
      if (e.target.name === 'hoja[]' || e.target.id === 'select_all_hojas') {
        this.updateHojaSummary();
      }
    });
  }

  // Las plantillas por bloques (ej. "Subsidio de salud") imprimen todo lo que definen:
  // el selector de Hojas se bloquea y se muestra qué incluye la plantilla.
  cambiarPlantilla() {
    if (!this.hasPlantillaTarget) return

    const option = this.plantillaTarget.selectedOptions[0]
    const permiteHojas = this.permiteHojas()

    if (this.hasHojasToggleTarget) {
      this.hojasToggleTarget.disabled = !permiteHojas
      this.hojasToggleTarget.classList.toggle('disabled', !permiteHojas)
      this.hojasToggleTarget.title = permiteHojas ? '' : 'La plantilla elegida incluye todas las hojas'
    }

    if (!permiteHojas) {
      this.hojaTargets.forEach(cb => { cb.checked = false })
      const selectAll = this.element.querySelector('#select_all_hojas')
      if (selectAll) selectAll.checked = false
    }

    this.updateHojaSummary()

    if (!permiteHojas && this.hasSelectedListTarget) {
      this.selectedListTarget.textContent = 'Todas, según la plantilla'
    }

    if (this.hasPlantillaDescripcionTarget) {
      const descripcion = permiteHojas ? '' : (option?.dataset.descripcion || '')
      this.plantillaDescripcionTarget.textContent = descripcion
      this.plantillaDescripcionTarget.classList.toggle('d-none', descripcion === '')
    }
  }

  permiteHojas() {
    if (!this.hasPlantillaTarget) return true

    const option = this.plantillaTarget.selectedOptions[0]
    return !option || option.dataset.permiteHojas !== 'false'
  }

  updateHojaSummary() {
    const hojas = (this.hojaTargets || []).filter(cb => cb.checked).map(cb => cb.value)
    const count = hojas.length

    if (this.hasCountTarget) this.countTarget.textContent = count

    if (this.hasSelectedListTarget) {
      if (count === 0) this.selectedListTarget.textContent = 'Todas'
      else {
        const max = 5
        const shown = hojas.slice(0, max).join(', ')
        this.selectedListTarget.textContent = hojas.length > max ? `${shown}, ...` : shown
      }
    }
  }

  imprimir(event) {
    event.preventDefault()
    if (this.submitting) return

    const trigger = event.currentTarget
    this.submitting = true
    trigger.classList.add('disabled')

    const desde = this.desdeTarget?.value
    const hasta = this.hastaTarget?.value
    const hojas = this.permiteHojas() ? (this.hojaTargets || []).filter(cb => cb.checked).map(cb => cb.value) : []

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("registro", this.registroValue)

    if (hojas.length > 0) {
      hojas.forEach(h => url.searchParams.append("hoja[]", h))

      if (this.hasTypesCountValue && hojas.length === this.typesCountValue) {
        url.searchParams.set('include_archivos', '1')
      }
    }
    if (desde && desde.trim() !== "") {
      url.searchParams.set("start_date", desde)
    }
    if (hasta && hasta.trim() !== "") {
      url.searchParams.set("end_date", hasta)
    }
    if (this.hasPlantillaTarget && this.plantillaTarget.value) {
      url.searchParams.set("plantilla", this.plantillaTarget.value)
    }

    if (url.pathname === "/" || url.pathname === "") {
      console.warn("buscar-reportes: URL appears empty or points to origin; check data-buscar-reportes-url-value")
    }

    window.open(url.toString(), "_blank")
    this.armCooldown(trigger)
  }

  imprimirLote(e) {
    e.preventDefault()
    if (this.submitting) return

    const trigger = e.currentTarget
    this.submitting = true
    trigger.classList.add('disabled')

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("start_date", this.desdeTarget.value)
    url.searchParams.set("end_date", this.hastaTarget.value)
    url.searchParams.set("obra_social", this.obraSocialTarget.value)

    window.open(url.toString(), "_blank")
    this.armCooldown(trigger)
  }

  armCooldown(trigger) {
    setTimeout(() => {
      this.submitting = false
      trigger.classList.remove('disabled')
    }, PRINT_COOLDOWN_MS)
  }
}
